import { render, staticRenderFns } from "./trainingFooter.vue?vue&type=template&id=0fbf9cbc&"
import script from "./trainingFooter.vue?vue&type=script&lang=js&"
export * from "./trainingFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports